import { FaroText, grey } from "@faro-lotv/flat-ui";
import { Divider, Stack, useMediaQuery } from "@mui/material";
import type { JSX } from "react";
import { RegionPanel } from "./region-step";
import { ScansPanel } from "./scans-step";

/** @returns the scan selection and the size of the area they define with the region box */
export function DefineAreaPanel(): JSX.Element {
  const isTouch = useMediaQuery("(pointer: coarse)");
  return (
    <Stack sx={{ gap: 2, flexGrow: 1 }}>
      <ScansPanel />
      <Divider />
      <RegionPanel />
      {isTouch && (
        // The handles of the box react to the mouse only, see the lotv BoxControls
        <FaroText variant="bodyS" color={grey[600]}>
          To change the box, pinch and move the view to the area you need, then
          tap Auto-clip to fit the box to it.
        </FaroText>
      )}
    </Stack>
  );
}
